module.exports = __webpack_public_path__ + "img/gxlogo6.067f942d.png";